var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77148 5.25H8.27148V3.75H6.77148V5.25ZM7.52148 13.5C4.21398 13.5 1.52148 10.8075 1.52148 7.5C1.52148 4.1925 4.21398 1.5 7.52148 1.5C10.829 1.5 13.5215 4.1925 13.5215 7.5C13.5215 10.8075 10.829 13.5 7.52148 13.5ZM7.52148 0C6.53657 0 5.5613 0.193993 4.65136 0.570904C3.74142 0.947814 2.91462 1.50026 2.21818 2.1967C0.811661 3.60322 0.0214844 5.51088 0.0214844 7.5C0.0214844 9.48912 0.811661 11.3968 2.21818 12.8033C2.91462 13.4997 3.74142 14.0522 4.65136 14.4291C5.5613 14.806 6.53657 15 7.52148 15C9.51061 15 11.4183 14.2098 12.8248 12.8033C14.2313 11.3968 15.0215 9.48912 15.0215 7.5C15.0215 6.51509 14.8275 5.53982 14.4506 4.62987C14.0737 3.71993 13.5212 2.89314 12.8248 2.1967C12.1283 1.50026 11.3016 0.947814 10.3916 0.570904C9.48167 0.193993 8.5064 0 7.52148 0V0ZM6.77148 11.25H8.27148V6.75H6.77148V11.25Z",
    fill: "#747474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfo);
export default __webpack_public_path__ + "static/media/tooltip_info.403cef469018b50df709b0e8e50abb77.svg";
export { ForwardRef as ReactComponent };